import React from 'react';
import VideoJSIFrame from './VideoJsIFrame';
import DOMPurify from 'dompurify';

import '../CSS/digitalassetvideo.css';

const InteractiveSingleVideo: React.FC<{ element: any }> = ({ element }) => {
  const videoJsOptions = {
    autoplay: true,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [
      {
        src: `https://players.brightcove.net/${element.brightcove_account_id.value}/${element.brightcove_player_id.value}_default/index.html?videoId=${element.brightcove_video_id.value}&interactivityProjectId=${element.brightcove_project_id.value}`,
        type: 'application/vnd.apple.mpegurl',
      },
    ],
  };

  // Utility function to check if rich text contains meaningful content
  const hasMeaningfulText = (richText: any): boolean => {
    if (!richText?.value) return false; // Check if value exists
    const strippedText = DOMPurify.sanitize(richText.value, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    }).trim(); // Remove all HTML tags and trim whitespace
    return strippedText.length > 0; // Return true if content has any non-empty text
  };

  // Fallback for alt text
  const altText = element.description___alt_text?.value || 'Video content';

  return (
    <>
      <div>
        <div className="da-title">{element.title?.value}</div>
        <div className="toolbox-panel-body embed-responsive embed-responsive-16by9">
          <VideoJSIFrame options={videoJsOptions} altText={altText} />
        </div>
        <div className="da-footer" style={{ marginTop: '0' }}>
          <span className="daid" style={{ textAlign: 'left' }}>
            {hasMeaningfulText(element.permission_language) &&
              DOMPurify.sanitize(element.permission_language?.value, {
                ALLOWED_TAGS: [],
                ALLOWED_ATTR: [],
              }).trim()}
            {element.digital_asset_id?.value &&
              ` [${element.digital_asset_id?.value}]`}
          </span>
        </div>
      </div>
    </>
  );
};
export default InteractiveSingleVideo;
